/**
 * The two capabilities the loader needs that are spelled differently in a
 * window and in a worker. Everything else it does is arithmetic, so this is the
 * whole of the portability layer.
 */

/* A 2D drawing surface. The atlas and the mark are rasterised into one of these
   and then handed to WebGL, which takes either kind as a texture source — so
   the only question is which constructor exists here. `document` is absent in a
   worker and `OffscreenCanvas` is absent in older browsers, so neither can be
   assumed; between them they cover everywhere this runs. */
export const surface =
  typeof OffscreenCanvas === 'function'
    ? (w, h) => new OffscreenCanvas(w, h)
    : (w, h) => Object.assign(document.createElement('canvas'), { width: w, height: h });

/* Decode the mark's SVG into something drawable. `Image` is a DOM element and
   does not exist in a worker; `createImageBitmap` does, and takes a blob. The
   explicit width and height matter to both — an SVG carrying only a viewBox has
   an intrinsic size of 300×150 and is stretched to it otherwise. */
export const decodeSvg =
  typeof Image === 'function'
    ? (svg) =>
        new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => resolve(img);
          img.onerror = reject;
          img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
        })
    : (svg) => createImageBitmap(new Blob([svg], { type: 'image/svg+xml' }));

